import { createSlice } from "@reduxjs/toolkit";
import { InitialIntegrationReducer } from "../../../../_services/store/InitialIntegrationReducer";
import { ConfigurationFieldNames } from "../../../../_statics/ConfigurationStatics";
import { integrationReducerActions } from "../../../../_commons/integration.reducer";

const initialNewConfiguration = {
    [ConfigurationFieldNames.PLATFORM_CLIENT_UUID]: "",
    [ConfigurationFieldNames.AUTO_SETUP]: false,
    [ConfigurationFieldNames.ACCOUNT_NUMBER_LENGTH]: null,
    [ConfigurationFieldNames.ACCOUNTING_SYSTEM]: null,
    [ConfigurationFieldNames.USE_MOSS]: false,
};

export const initialStripeBillingReducer = {
    ...new InitialIntegrationReducer(),
    newConfiguration: { ...initialNewConfiguration },
};

const stripeBillingSlice = createSlice({
    name: "StripeBilling",
    initialState: { ...initialStripeBillingReducer },
    reducers: {
        ...integrationReducerActions,
        triggerImportRequest(state) {
            state.importErrorMessage = null;
            state.isImportLoading = true;
            state.importSuccessMessage = null;
        },
        triggerImportSuccess(state, action) {
            state.configuration = action.payload;
            state.editConfiguration = action.payload;
            state.importErrorMessage = null;
            state.isImportLoading = false;
            state.importSuccessMessage = "Der Import wurde erfolgreich gestartet";
        },
        triggerImportFailure(state, action) {
            state.importErrorMessage = action.payload;
            state.isImportLoading = false;
            state.importSuccessMessage = null;
        },
        triggerPRAPImportRequest(state) {
            state.importErrorMessage = null;
            state.isImportLoading = true;
            state.importSuccessMessage = null;
        },
        triggerPRAPImportSuccess(state, action) {
            state.configuration = action.payload;
            state.editConfiguration = action.payload;
            state.importErrorMessage = null;
            state.isImportLoading = false;
            state.importSuccessMessage = "PRAP Berechnung wurde erfolgreich gestartet";
        },
        triggerPRAPImportFailure(state, action) {
            state.importErrorMessage = action.payload;
            state.isImportLoading = false;
            state.importSuccessMessage = null;
        },
        triggerWorkdayImportRequest(state) {
            state.importErrorMessage = null;
            state.isImportLoading = true;
            state.importSuccessMessage = null;
        },
        triggerWorkdayImportSuccess(state, action) {
            state.configuration = action.payload;
            state.editConfiguration = action.payload;
            state.importErrorMessage = null;
            state.isImportLoading = false;
            state.importSuccessMessage = "Der Import wurde erfolgreich gestartet";
        },
        triggerWorkdayImportFailure(state, action) {
            state.importErrorMessage = action.payload;
            state.isImportLoading = false;
            state.importSuccessMessage = null;
        },
    },
});

export default stripeBillingSlice;
